<template>
  <div class="">
    <!-- <div
      class="h-[33px] bg-[linear-gradient(180deg,rgba(10,10,10,0.00)_0%,#0A0A0A_100%)] mb-[-1px]'"
    /> -->
    <div :class="[isAndroid ? 'pb-4' : 'pb-8', 'flex items-center bg-back-1']">
      <router-link
        v-for="item in menu"
        :key="item.name"
        :to="item.path"
        class="text-2xs w-1/4 flex flex-col items-center py-2"
        @click="handleClick(item)">
        <component class="w-6 h-6 mb-1" :is="icons[item.icon]" :active="getActive(item)" />
        <span>{{ item.name }}</span>
      </router-link>
    </div>
  </div>
</template>

<script setup>
import { useI18n } from "vue-i18n";
import { useRoute, useRouter } from "vue-router";
import { computed } from "vue";
import coinhold from "@/components/nav/tabbar/icons/coinhold.vue";
import p2p from "@/components/nav/tabbar/icons/p2p.vue";
import wallet from "@/components/nav/tabbar/icons/wallet.vue";
import user from "@/components/nav/tabbar/icons/user.vue";
import apps from "@/components/nav/tabbar/icons/apps.vue";
import card from "@/components/nav/tabbar/icons/card.vue";
import { baseAnalytics } from "@/utils/analytics/base";

const { t } = useI18n();
const route = useRoute();
const router = useRouter();

const icons = {
  coinhold,
  p2p,
  wallet,
  user,
  apps,
  card,
};

const isAndroid = typeof navigator !== "undefined" && /Android/i.test(navigator.userAgent || "");

const menu = computed(() => [
  {
    name: t("other|dashboardPage|dashboard"),
    path: "/dashboard",
    icon: "wallet",
    parent: "Dashboard",
    title_for_analytics: "dashboard_tab",
  },
  {
    name: t("other|dashboardPage|p2p"),
    path: "/p2p",
    icon: "p2p",
    parent: "P2P",
    title_for_analytics: "p2p_tab",
  },
  // Apps tab hidden: only entry point was gift cards, which were closed (MVP hypothesis not confirmed, backend closed)
  // {
  //   name: t("other|dashboardPage|apps"),
  //   path: "/apps",
  //   icon: "apps",
  //   parent: "Apps",
  //   title_for_analytics: "webs_tab",
  // },
  {
    name: t("giftcards|card"),
    // path: activeCardId.value ? `/card/${activeCardId.value}` : "/card",
    path: "/card",
    icon: "card",
    parent: "Card",
    title_for_analytics: "card_tab",
  },
  {
    name: t("other|dashboardPage|earn"),
    path: "/coinhold",
    icon: "coinhold",
    parent: ["Coinhold", "Staking"],
    title_for_analytics: "earn_tab",
  },
  {
    name: t("other|dashboardPage|profile"),
    path: "/profile/base",
    icon: "user",
    parent: "Profile",
    title_for_analytics: "profile_tab",
  },
]);

const handleClick = (item) => {
  baseAnalytics.navbarNavigate(item.title_for_analytics, route.name);
  router.push(item.path);
};

const getActive = (item) => {
  const routeName = String(route.name || "").toLowerCase();
  // meta.parent handles routes whose name doesn't contain the tab key (e.g. WaitingKyc → Card)
  const metaParent = String(route.meta?.parent || "").toLowerCase();
  const parents = Array.isArray(item.parent) ? item.parent : [item.parent];
  return parents.some((parent) => {
    const key = String(parent || "").toLowerCase();
    return routeName.includes(key) || metaParent === key;
  });
};
</script>
